module.exports = __webpack_public_path__ + "media/images/mobile/dummy03-ba0c3ab232f6eec15eef41520991d3fa.jpg";